import React, { useState } from "react";
import { createCheckoutSession } from "../services/paymentService"; // Import the payment service

const PaymentPage = ({ emissionId, email, amount }) => {
  // local state for editable amount
  const [customAmount, setCustomAmount] = useState(amount);

  const handlePayment = async () => {
    try {
      const sessionUrl = await createCheckoutSession(
        emissionId,
        email,
        customAmount
      ); // send custom amount
      window.location.href = sessionUrl; // Redirect to Stripe checkout
    } catch (error) {
      console.error(error.message);
      alert("Failed to initiate payment. Please try again.");
    }
  };

  return (
    <div className="container mt-3 mb-2 text-center">
      <div className="text-center">
        {/* Input with USD suffix */}
        <div className="input-group mb-3">
          <input
            type="number"
            step="0.01"
            className="form-control"
            value={customAmount}
            onChange={(e) => setCustomAmount(parseFloat(e.target.value))}
            placeholder="Enter amount"
          />
          <span className="input-group-text">USD</span>
        </div>
      </div>
      <button
        className="btn btn-success mt-3 w-100"
        style={{
          backgroundColor: " #00e68a",
          // fontFamily: "Lato, sans-serif",
          color: "white",
          border: "none",
        }}
        onClick={handlePayment}
      >
        Pay & View Reports
      </button>
    </div>
  );
};

export default PaymentPage;
